module.exports = __webpack_public_path__ + "img/vip.fa6e7bf3.png";